module.exports = __webpack_public_path__ + "media/images/desktop/messenger-icon-bright-fed665d71a289ed0bca4da6730bcb0bb.svg";